export default __webpack_public_path__ + "d206a38febdf903c61d26d234185d894.svg";